import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function Psychology() {
  return <section className="relative isolate overflow-hidden bg-brand-950 py-16 sm:py-28" data-id="element-178" data-mp="2q7yfg8h2hto6">
      <div aria-hidden="true" className="absolute inset-0 opacity-70" data-id="element-179" data-mp="2v5qhhvbfew63">
        <svg viewBox="0 0 1200 400" className="h-full w-full" preserveAspectRatio="none" data-id="element-180" data-mp="2z7lg2s1z2vg6">
          <path d="M0 320 C 140 300, 190 190, 300 210 C 410 230, 460 120, 580 150 C 700 180, 740 70, 860 110 C 980 150, 1050 60, 1200 40" fill="none" stroke="rgba(92,124,255,0.55)" strokeWidth="1.4" data-id="element-181" data-mp="346oe3sjjc1en" />
          <path d="M0 370 C 160 350, 220 280, 340 300 C 470 322, 520 230, 650 250 C 790 272, 840 190, 1000 205 C 1100 214, 1150 180, 1200 170" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="1" data-id="element-182" data-mp="3dwzuiekeo32f" />
        </svg>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,rgba(47,85,255,0.35),transparent_60%)]" data-id="element-183" data-mp="3rvhafq42kb9s" />
      </div>

      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8" data-id="element-184" data-mp="2g2c0xsgvhhju">
        <Reveal data-id="element-185" data-mp="2bymdx7fuj80x">
          <h2 className="text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-[2.75rem]" data-id="element-186" data-mp="2by47jhzgzdfa">
            No se trata de perseguir el mercado.
            <span className="mt-2 block text-brand-400" data-id="element-187" data-mp="22219an7qnyxm">
              Se trata de estar preparado.
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-188" data-mp="2zr2yppqyxe3x">
          <p className="mx-auto mt-7 max-w-2xl text-[15.5px] leading-relaxed text-white/65" data-id="element-189" data-mp="2updi7ukz888g">
            Los mercados cambian constantemente. Tener una plataforma adecuada te
            permite explorar tus decisiones de trading desde un entorno digital
            diseñado para traders.
          </p>
        </Reveal>

        <Reveal delay={0.12} data-id="element-190" data-mp="3igj8z4sggkxj">
          <p className="mx-auto mt-9 inline-flex rounded-full border border-white/20 bg-white/[0.07] px-6 py-3 text-[11.5px] font-semibold uppercase tracking-overline text-brand-200" data-id="element-191" data-mp="3igsqe3zfpjrm">
            Preparación + Disciplina + Gestión del riesgo
          </p>
        </Reveal>

        <Reveal delay={0.16} data-id="element-192" data-mp="1frrhbw4rupyp">
          <div className="mt-9" data-id="element-193" data-mp="1fux434pxhfr9">
            <CTAButton label="Quiero empezar" location="psychology" size="lg" variant="white" className="w-full sm:w-auto" data-id="element-194" data-mp="121nw98hmp2au" />
          </div>
        </Reveal>
      </div>
    </section>;
}